import React from "react";
import * as styles from "./styles.module.scss";

function SiteGrid({ children, className }) {
  return (
    <div className={`${styles.grid} ${styles[className]}`}>{children}</div>
  );
}

export default SiteGrid;
